import { RedirectParamsHistorical } from '../../../../../shared/types/redirectParams';

export interface RedirectParamsHistoricalProps {
    historical: RedirectParamsHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    name: 'Nombre',
    parent: 'Área',
    extra: 'Correo',
    extra2: 'Observación',
    active: 'Estado',
};
